// @file Data Access Layer helpers

import { currentHostname } from '@@/bits/location'
import { DataAccessLayer } from '@padlet/dalfe'

const dal = new DataAccessLayer({
  host: currentHostname(),
  token: 'TODO',
})

export default dal
